import React, { FC } from "react";
import FormHelperText from "@mui/material/FormHelperText";

interface Props {
  children: React.ReactNode;
  htmlFor?: string;
}

export const InputError: FC<Props> = ({ children, htmlFor }) => (
  <FormHelperText error component="label" htmlFor={htmlFor} sx={{ marginTop: "5px" }}>
    {children}
  </FormHelperText>
);
